import { Component, HostListener } from "@angular/core";
import { StoreService } from "src/app/shared/services/store.service";
import { environment } from "src/environments/environment";
import { Lottie } from "src/app/shared/constant/lottie";
import { Router } from "@angular/router";
import { GtmService } from "src/app/shared/services/gtm-service/gtm.service";

@Component({
    selector: "web-take-picture",
    templateUrl: "./take-picture.component.html",
    styleUrls: ["./take-picture.component.scss"],
})
export class TakePictureComponent {
    private baseUrl = environment.baseUrl;
    popupRef: Window | null = null;

    constructor(
        private storeService: StoreService,
        private router: Router,
        public lottieFile: Lottie,
        public gtmService: GtmService
    ) {}

    startZoopLiveness() {
        const token = this.storeService.get("token");
        if (!token) {
            console.warn("Token not found.");
            return;
        }

        const popupUrl = `${this.baseUrl}/zoop/profile-retake/initiate?token=${token}`;

        const width = 800;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const popupFeatures = `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`;

        if (!this.popupRef || this.popupRef.closed) {
            this.popupRef = window.open(popupUrl, "_blank", popupFeatures);
        }
    }

    @HostListener("window:message", ["$event"])
    onPopupMessage(event: MessageEvent): void {
        const msgType = event?.data?.event;

        switch (msgType) {
            case "liveness-success":
                this.gtmService.trackConfigEvent("SELFIE_VERIFIED_SUCCESS", {
                    verification_time: new Date().toISOString(),
                });
                setTimeout(() => {
                    this.forceClosePopup(true);
                }, 500);
                break;

            case "liveness-error":
            case "liveness-cancelled":
                this.gtmService.trackConfigEvent("SELFIE_VERIFIED_FAIL", {
                    failure_reason: msgType === "liveness-cancelled" ? "User cancelled" : "Liveness check failed",
                });
                this.forceClosePopup();
                break;
        }
    }

    private forceClosePopup(status: boolean = false): void {
        if (status && this.popupRef) {
            this.popupRef.close();
            this.popupRef = null;
            this.showSuccessDialog();
        } else {
            this.router.navigate(["/loan/info"], {
                state: {
                    icon: "assets/svg/icons/error_ic.svg",
                    title: "Selfie Verification Failed.",
                    redirect: 5,
                    redirectRoute: "/loan/timeline",
                    rightButtonName: "Retake Selfie",
                    rightButtonRoute: "/loan/timeline",
                },
            });
        }
    }

    private showSuccessDialog(): void {
        this.router.navigate(["/loan/info"], {
            state: {
                icon: "assets/svg/icons/badge-success-gb.svg",
                title: "Selfie verified you're all good to go!.",
                redirect: 5,
                redirectRoute: "/loan/timeline",
                rightButtonName: "Save & exit",
                rightButtonRoute: "/loan/timeline",
            },
        });
    }
}
